import React from "react";
import TitleItem from "../../../../viewer/chart/TitleItem.tsx";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import { valueAxisTitle } from "./valueAxisUtils.ts";
import type { ChartStyleSettings, ValueAxis } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  axis: ValueAxis;
  readonlyMode: boolean;
}

export default function Title({ settings, axis, readonlyMode }: Props) {
  const title = React.useMemo(() => valueAxisTitle(settings, axis.name), [settings, axis.name]);
  const dispatch = useAppDispatch();

  return (
    <TitleItem
      title={title}
      placeholder="Set Axis Title..."
      disabled={readonlyMode}
      onUpdate={(title) =>
        dispatch(fieldsStateActions.updateAxisValueSettings({ name: axis.name, changes: { title } }))
      }
    />
  );
}
